<style lang="scss" scoped>
.order {
  width: 600px;

  .num {
    width: 36px;
  }
  .close {
    width: 20px;
  }
}

.input-width {
  width: 160px;
}
</style>

<template>
  <div>
    <modal title="销售" v-model="showModal" width="700">
      <i-form inline>
        <Row>
          <Form-item label="客户" class="input-width">
            <i-input v-model="form.customerName" placeholder="请输入"></i-input>
          </Form-item>
          <Form-item label="电话" class="input-width">
            <i-input
              v-model="form.customerPhone"
              placeholder="请输入"
            ></i-input>
          </Form-item>
          <Form-item label="工程师" class="input-width">
            <i-select v-model="form.sale" placeholder="请选择工程师">
              <i-option value></i-option>
              <i-option v-for="u in users" :value="u.uid" :key="u.uid">{{
                u.name
              }}</i-option>
            </i-select>
          </Form-item>
        </Row>
        <Row>
          <Form-item label="主机编号" class="input-width">
            <i-input v-model="form.sn" placeholder="请输入"></i-input>
          </Form-item>
          <Form-item label="工单编号" class="input-width">
            <i-input v-model="form.soid" placeholder="请输入"></i-input>
          </Form-item>
          <Form-item label="岗位" class="input-width">
            <i-select v-model="form.engineerPost" placeholder="请选择岗位">
              <i-option value></i-option>
              <i-option value="0">送修</i-option>
              <i-option value="1">上门</i-option>
              <i-option value="2">内勤</i-option>
            </i-select>
          </Form-item>
        </Row>
        <Row>
          <Form-item label="是否开票" class="input-width">
            <i-select v-model="form.invoice" placeholder="请选择">
              <i-option value="0">否</i-option>
              <i-option value="1">是</i-option>
            </i-select>
          </Form-item>
          <Form-item label="开票金额" class="input-width">
            <Input-number
              v-model="form.invoiceValue"
              :min="0"
              style="width: 100%"
            ></Input-number>
          </Form-item>
        </Row>
        <Row>
          <Form-item label="备注">
            <i-input
              v-model="form.note"
              type="textarea"
              style="width: 500px"
            ></i-input>
          </Form-item>
        </Row>
        <Row>
          <Form-item style="width: 500px">
            <i-col span="18">
              <i-select
                ref="product"
                v-model="productSelect"
                remote
                :remote-method="findProduct"
                filterable
                clearable
              >
                <i-option
                  v-for="item in products"
                  :value="item.value"
                  :key="item.id"
                  >{{ item.label }}</i-option
                >
              </i-select>
            </i-col>
            <i-col span="6">
              <i-button
                type="dashed"
                long
                @click="handleAdd"
                icon="plus-round"
                style="margin-left: 5px"
              >
                新增
              </i-button>
            </i-col>
          </Form-item>
        </Row>
      </i-form>
      <table class="order">
        <tr>
          <th class="product">商品</th>
          <th class="num">数量</th>
          <th class="num">单价</th>
          <th class="num">合计</th>
          <th class="close"></th>
        </tr>
        <tr v-for="(i, index) in form.items" :key="i.categoryId">
          <td>{{ i.name }}</td>
          <td>
            <Input-number v-model="i.num" :min="1"></Input-number>
          </td>
          <td>
            <Input-number v-model="i.price" :min="0"></Input-number>
          </td>
          <td>{{ i.num * i.price }}</td>
          <td>
            <Icon type="md-close" color="red" @click="del(index)"></Icon>
          </td>
        </tr>
        <tr>
          <td colspan="3"></td>
          <td>{{ total }}</td>
        </tr>
      </table>

      <div slot="footer">
        <i-button @click="close">取消</i-button>
        <i-button type="primary" @click="ok">确认</i-button>
      </div>
    </modal>
  </div>
</template>

<script>
import find from 'lodash.find';
import { mapGetters } from 'vuex';

const createForm = () => {
  return {
    customerName: '',
    customerPhone: '',
    soid: '',
    sn: '',
    engineerPost: '',
    sale: '',
    serviceCharge: 0,
    freight: 0,
    note: '',
    invoiceValue: 0,
    items: [],
  };
};

let lock = false;

export default {
  data() {
    return {
      showModal: false,
      products: [],
      form: createForm(),
      productSelect: '',
      users: [],
    };
  },
  computed: {
    ...mapGetters(['user']),
    total() {
      let items = this.form.items;
      let total = 0;
      items.forEach((i) => {
        total += i.num * i.price;
      });
      return total;
    },
  },
  mounted() {
    this.$http.post('account/find').then(({ data }) => {
      if (data.msg === 'ok') {
        this.users = data.users;
        this.form.sale = this.user.uid;
      }
    });

    this.findProduct();
  },
  methods: {
    close() {
      this.showModal = false;
    },
    ok() {
      this.handleSubmit('formValidate');
    },
    handleSubmit() {
      let {
        customerName,
        customerPhone,
        soid,
        sn,
        serviceCharge,
        engineerPost,
        sale,
        freight,
        items,
        note,
        invoice,
        invoiceValue,
      } = this.form;

      let valid =
        typeof invoice == 'string' &&
        customerName &&
        customerPhone &&
        engineerPost !== '' &&
        items.length > 0;
      if (valid) {
        for (let i of items) {
          if (!(i.categoryId && i.num && i.price >= 0)) valid = false;
        }
      }

      if (valid && !lock) {
        lock = true;
        setTimeout(() => {
          lock = false;
        }, 5000);
        this.$http
          .post('product/order', {
            invoice,
            invoiceValue,
            name: customerName,
            phone: customerPhone,
            engineerPost,
            sale,
            soid,
            sn,
            serviceCharge,
            freight,
            items,
            note,
          })
          .then(({ data }) => {
            if (data.msg === 'ok') {
              this.$Message.success('提交成功!');
              this.showModal = false;
              this.form = createForm();
              this.$emit('finish');
            } else {
              this.$Message.error(data.msg);
            }
          });
      } else {
        this.$Message.error('表单验证失败!');
      }
    },
    handleAdd() {
      let categoryId = this.productSelect;
      let item = find(this.form.items, {
        categoryId,
      });
      if (!item) {
        let cate = find(this.products, {
          value: categoryId,
        });
        if (cate) {
          this.form.items.push({
            name: cate.label,
            categoryId,
            num: 1,
            price: 1,
          });
          this.$refs.product.clearSingleSelect();
        }
      }
    },
    del(index) {
      this.$delete(this.form.items, index);
    },
    show() {
      this.showModal = true;
    },
    findProduct(query) {
      this.$http
        .post('product/find', {
          name: query,
          limit: 200,
        })
        .then(({ data: { rows } }) => {
          if (rows?.length > 0) {
            this.products = rows.map((r) => {
              return {
                label: r.categoryId + ' ' + r.name,
                value: r.categoryId,
                cost: r.unitPrice,
              };
            });
          }
        });
    },
  },
};
</script>
